export const capitalize = (stringValue) => {
  if (typeof stringValue !== 'string' || !stringValue) return '';
  return stringValue.charAt(0).toUpperCase() + stringValue.slice(1).toLowerCase();
};
